import jsPDF from 'jspdf'
import 'jspdf-autotable'
import * as Addons from '../../utilities/Addons'

export const atelierTable = ateliers => {
    const doc = new jsPDF('p', 'mm')
    let nbPage = 1
    let head = ['#', 'Date', 'Nom', 'Marque', 'Plaques', 'Etat', 'Mécanicien', 'Total']
    let options = {
        // theme: 'grid',
        styles: {
            font: 'times'
        },
        headStyles: {
            valign: 'middle',
            halign: 'center'
        },
        bodyStyles: {
            valign: 'middle',
            halign: 'center'
        },
        didDrawPage: () => {
            doc.setFontSize(8)
            doc.setFont(undefined, 'normal')
            doc.setFont('times')
            doc.text(nbPage.toString(), 105, 290, 'center')
            nbPage++
        }
    }
    let body = []
    let index = 1
    for (let atelier of ateliers) {
        let temp = []
        temp.push(index)
        temp.push(atelier.date)
        temp.push(atelier.nom)
        temp.push(atelier.marque)
        temp.push(atelier.plaques)
        temp.push(atelier.etat)
        temp.push(atelier.employe)
        temp.push(Addons.round100(atelier.total))
        body.push(temp)
        index++
    }
    doc.autoTable(
        head,
        body,
        options
    )
    doc.save()
}